module.exports = __webpack_public_path__ + "static/012-9fe6fe672c8bb8ec49e4652996b55f19.jpg";